/*
 * Auto snap-on-scroll for Bootstrap Row / Column sections — visibility trigger.
 *
 * The native CSS snap (cuyana-snap.css: scroll-snap-type proximity) handles the
 * smooth close-range lock and holds the final position. This script only widens
 * the *catch*: when the reader stops scrolling and a snap-enabled section is at
 * least VISIBILITY_RATIO of its own height inside the viewport, it eases that
 * section's top into place with ONE native smooth scroll (scrollIntoView, which
 * respects scroll-margin-top). No per-frame scrolling — nothing fights the
 * browser's momentum/inertia — so it stays as smooth as the native snap.
 *
 * One global controller handles every [data-auto-snap="true"] element. Opt-in
 * per section via the "Auto snap on scroll" setting (default off).
 */
(function () {
  if (window.__cuyBootstrapRowSnap) return;
  window.__cuyBootstrapRowSnap = true;

  // A section must have at least this fraction of its own height in view to be
  // pulled into place. At >=0.6 only one section can qualify at a time (two
  // adjacent full-height panels can't both show 60%), so the target is unambiguous.
  var VISIBILITY_RATIO = 0.6;
  // Already this close (px) to aligned — leave it to the native snap; don't
  // re-scroll (which would also risk a trigger loop).
  var ALIGN_TOLERANCE = 2;
  // Debounced fallback for browsers without 'scrollend'. Long enough that
  // inertial/momentum scrolling (Safari trackpads) has fully settled first.
  var SCROLLEND_FALLBACK_MS = 200;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsScrollEnd = 'onscrollend' in window;

  var isSnapping = false;
  var releaseTimer = null;
  var debounceTimer = null;

  function headerOffset() {
    var bodyStyles = window.getComputedStyle(document.body);
    var useSticky = parseInt(bodyStyles.getPropertyValue('--use-sticky-header'), 10) || 0;
    if (!useSticky) return 0;
    var docStyles = window.getComputedStyle(document.documentElement);
    return parseInt(docStyles.getPropertyValue('--header-height'), 10) || 0;
  }

  function scrollingLocked() {
    // A modal/drawer may have locked page scroll (e.g. bundlinator-open).
    return window.getComputedStyle(document.body).overflow === 'hidden'
      || window.getComputedStyle(document.documentElement).overflow === 'hidden';
  }

  function pickTarget() {
    var sections = document.querySelectorAll('.BootstrapRow[data-auto-snap="true"], .BootstrapCol[data-auto-snap="true"]');
    if (!sections.length) return null;

    var offset = headerOffset();
    var viewH = window.innerHeight;
    var best = null;
    var bestRatio = 0;

    for (var i = 0; i < sections.length; i++) {
      var el = sections[i];
      if (el.offsetParent === null) continue; // hidden (e.g. d-none visibility)
      var rect = el.getBoundingClientRect();
      if (rect.height <= 0) continue;
      // Height visible within the area below the sticky header.
      var visible = Math.min(rect.bottom, viewH) - Math.max(rect.top, offset);
      if (visible <= 0) continue;
      var ratio = visible / rect.height;
      if (ratio >= VISIBILITY_RATIO && ratio > bestRatio) {
        bestRatio = ratio;
        best = el;
      }
    }

    if (!best) return null;
    // Already aligned (the native snap has it) — nothing to do.
    var distance = best.getBoundingClientRect().top - offset;
    if (Math.abs(distance) <= ALIGN_TOLERANCE) return null;
    return best;
  }

  function onScrollEnd() {
    // The scrollend that follows our own snap: clear the flag and stop.
    if (isSnapping) {
      isSnapping = false;
      if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
      return;
    }
    if (scrollingLocked()) return;
    // Skip while the user is typing in a field.
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;

    var target = pickTarget();
    if (!target) return;

    isSnapping = true;
    // Single native smooth scroll; block:'start' honors scroll-margin-top.
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Fallback release in case scrollend never fires.
    if (releaseTimer) clearTimeout(releaseTimer);
    releaseTimer = setTimeout(function () {
      isSnapping = false;
      releaseTimer = null;
    }, 900);
  }

  function onScrollDebounced() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(onScrollEnd, SCROLLEND_FALLBACK_MS);
  }

  function bind() {
    if (reduceMotion) return; // motion feature — leave scrolling untouched
    if (supportsScrollEnd) {
      window.addEventListener('scrollend', onScrollEnd, { passive: true });
    } else {
      window.addEventListener('scroll', onScrollDebounced, { passive: true });
    }
  }

  bind();
})();
